import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import React, { useEffect, useState } from 'react'

import { getPostHogInstance } from './posthog-integration.ts'

export function LazyPostHogProvider({ children }: { children: React.ReactNode }): React.ReactNode {
  const [posthogInstance, setPosthogInstance] = useState<typeof posthog | null>(null)

  useEffect(() => {
    // Use requestIdleCallback if available, fallback to setTimeout(0)
    // This ensures we don't block the main thread for initial render/hydration
    // and avoids synchronous setState calls within the effect body.
    const initPostHog = () => {
      const instance = getPostHogInstance()
      if (instance) {
        setPosthogInstance(instance)
      }
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(initPostHog)
    } else {
      setTimeout(initPostHog, 0)
    }
  }, [])

  if (posthogInstance) {
    return <PostHogProvider client={posthogInstance}>{children}</PostHogProvider>
  }

  return children
}
